import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { ApolloProvider } from '@apollo/client';
import client from '../wf/client';
import { BrowserRouter as Router } from 'react-router-dom';
import RedemptionEditor from './RedemptionEditor';
import SaveRedemptionBenefit from './SaveRedemptionBenefit';
const RedemptionApp = ({ id, businessId }) => {
    return (_jsx(ApolloProvider, { client: client, children: _jsx(Router, { children: _jsx("div", { id: "tw-root", children: _jsx("div", { id: "tw-main", className: "App container text-center", children: _jsxs("div", { className: "flex flex-wrap justify-center font-sans", children: [_jsx(RedemptionEditor, { id: id }), _jsx("div", { className: "w-full" }), _jsx(SaveRedemptionBenefit, { id: id })] }) }) }) }) }));
};
export default RedemptionApp;
